import { render, staticRenderFns } from "./MotorQuotePosted.vue?vue&type=template&id=3b5d0a4b&"
import script from "./MotorQuotePosted.vue?vue&type=script&lang=js&"
export * from "./MotorQuotePosted.vue?vue&type=script&lang=js&"
import style0 from "./MotorQuotePosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorQuotePosted.vue"
export default component.exports